import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'

export const TEAM_QUERY_KEY = (teamId: string) => ['team', teamId]

export const useTeam = (teamId: string) => {
  const { data: team, isLoading, error } = useQuery({
    queryKey: TEAM_QUERY_KEY(teamId),
    queryFn: () => dataSource.getTeam(teamId),
    enabled: !!teamId,
  })

  return {
    data: team ?? undefined,
    isLoading,
    error,
  }
}
